import React from 'react'

const SolidityScan = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5.67491V6.52488L0 6.52488L3.74671e-08 5.67491L12 5.67491Z" fill="currentColor"/>
    <path d="M1.71456 7.375V10.3496H4.71456V11.1992H0.857143V7.375H1.71456Z" fill="currentColor"/>
    <path d="M11.1433 11.1992H7.28585V10.3496H10.2859V7.375H11.1433V11.1992Z" fill="currentColor"/>
    <path d="M11.1433 4.8252H10.2859V1.84961H7.28585V1H11.1433V4.8252Z" fill="currentColor"/>
    <path d="M4.71456 1.84961H1.71456V4.8252H0.857143V1H4.71456V1.84961Z" fill="currentColor"/>
  </svg>
)
export default SolidityScan;